import script from "./InfoTile.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoTile.vue?vue&type=script&setup=true&lang=js"

import "./InfoTile.vue?vue&type=style&index=0&id=cb4cf7a2&lang=scss"

const __exports__ = script;

export default __exports__